export default class Cost {
  constructor(el) {
    this.el = el;
    this.init();
    this.initEvents();
  }

  init() {
    this.fillTable();
  }

  initEvents() {
    var select = this.el.querySelector("select");

    select.removeEventListener("change", (e) => this.handleChange(e));

    select.addEventListener("change", (e) => this.handleChange(e));
  }

  handleChange(e = {}) {
    this.fillTable();
  }

  fillTable() {
    var select = this.el.querySelector("select");
    var selectvalue = select.value.toLowerCase();
    var rows = this.el.querySelectorAll(".targetgroup-table");
    rows.forEach((row) => {
      var targetgroup = row.dataset.targetgroup;

      if (targetgroup != null && targetgroup.includes(selectvalue)) {
        row.style.display = "block";
      } else {
        row.style.display = "none";
      }
    });
  }
}
